<template>
  <div class="container user-profile">
    <breadcrumbs
      v-if="isAdmin"
      :breadcrumb-links="[{url:adminHomeURL, text: 'Admin home'},{text: 'Profile'}]"
    />
    <breadcrumbs
      v-else
      :breadcrumb-links="[{url:userHomeURL, text: 'Home'},{text: 'Profile'}]"
    />
    <div v-if="user" class="card card-ornament card-ornament--green">
      <h2>Welcome, {{ user.attributes.name }} <small><a href="#" class="sign-out" @click="onSignOutClick">Sign out</a></small></h2>
      <small v-if="userTitle">
        Logged in as {{ userTitle }}
      </small>
      <p>You can update the name, email address or phone number associated with your account below</p>
      <profile-form
        v-if="user"
        :user="user"
        :fields="fields"
      />
    </div>
  </div>
</template>

<script>
import metadata from '../util/metadata';
import routeNames from '../util/routeNames';
import { Auth } from 'aws-amplify';
import router from '../routes/router';
import Breadcrumbs from '../components/Breadcrumbs';
import roles from '../util/roles';
import store from '../store/store';

export default {
  name: 'Profile',
  components: { Breadcrumbs },
  data() {
    return {
      adminHomeURL: routeNames.ADMIN.PATH,
      userHomeURL: routeNames.ADDFAMILY.PATH,
      user: {},
      userTitle: '',
      mfa: false,
      fields: [
        { type: 'string', name: 'name', label: 'Name' },
        { type: 'string', name: 'email', label: 'Email' },
        { type: 'string', name: 'phone_number', label: 'Phone Number' }
      ],
    }
  },
  computed: {
    isAdmin() {
      return store.getters.getUserRole === roles.ADMIN;
    }
  },
  created() {
    this.user = this.$store.getters.getUser;
    this.userTitle = this.$store.getters.getUserTitle;
  },
  methods: {
    onSignOutClick: async function (event) {
      event.preventDefault();
      await Auth.signOut();
      this.$store.dispatch('logout');
      router.push(routeNames.AUTH.PATH);
    }
  },
  metaInfo: {
    title: `Profile | ${metadata.GLOBAL.PAGE_TITLE}`,
    meta: [
      { name: 'description', content: 'Reset your profile values here' }
    ]
  },
}
</script>
<style lang="scss">
@import "../styles/environment/_variables";

.user-profile {
  .sign-out {
    color: $sa-red-dark;
    text-decoration: underline;

    &:hover {
      color: $sa-red-hover;
      text-decoration: none;
    }
  }
}
</style>
